import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { fadeUp, revealProps, stagger, useReducedMotion } from "homepage-new/motion";
import { rf } from "../theme";
import { Band, Card, Display } from "../ui";

const WEEK = [
  { day: "Live class", fill: rf.coral, detail: "Two sessions a week, taught — not screen-shared slides. Questions interrupt the class; that is what live is for." },
  { day: "Build day", fill: rf.amber, detail: "One assignment a week, on the thing just taught. It lands in your own repository, not a sandbox you abandon later." },
  { day: "Code review", fill: rf.mint, detail: "Your code is read by the instructor and commented on. This is the part that does not scale, which is why the batch is capped." },
  { day: "Doubts hour", fill: rf.sky, detail: "A weekday hour where nothing is scheduled and anything can be asked, including the questions you think are too basic." },
  { day: "Checkpoint", fill: rf.lilac, detail: "Every few weeks the cohort demos progress to each other. Public enough to keep you honest, small enough to be safe." },
];

export const Rhythm = () => {
  const reduced = useReducedMotion();

  return (
    <Band
      id="rhythm"
      eyebrow="How a week actually runs"
      title="Five fixed things, every week"
      lead="A cohort works because the shape repeats. Here is the shape — so you can decide now whether it fits your life, rather than three weeks in."
    >
      <motion.div variants={stagger(0.07)} {...revealProps(reduced)}>
        <Grid container spacing={3}>
          {WEEK.map((item, i) => (
            <Grid item xs={12} sm={6} md={4} key={item.day}>
              <motion.div variants={fadeUp} style={{ height: "100%" }}>
                <Card sx={{ p: 3, height: "100%", textAlign: "left" }}>
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      mb: 2,
                      display: "grid",
                      placeItems: "center",
                      backgroundColor: item.fill,
                      border: rf.line,
                      borderRadius: rf.radiusSm,
                      boxShadow: rf.shadowSm,
                      fontFamily: rf.display,
                      fontWeight: 800,
                      fontSize: 16,
                    }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </Box>
                  <Display component="h3" size={21} sx={{ mb: 1 }}>
                    {item.day}
                  </Display>
                  <Typography sx={{ fontFamily: rf.body, fontSize: 14.5, color: rf.inkSoft, lineHeight: 1.6 }}>
                    {item.detail}
                  </Typography>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Band>
  );
};

export default Rhythm;
